import axios from "axios";
class or_api {
  constructor(axiosFactory) {
    this.$http = axiosFactory;
  }
  http() {
    return this.$http;
  };
  get(url, cb) {
    this.$http.get(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  gets(url, data, cb) {
    this.$http.get(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  post(url, data, cb) {
    this.$http.post(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  posts(url, cb) {
    this.$http.post(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  put(url, data, cb) {
    this.$http.put(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  puts(url, cb) {
    this.$http.put(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  delete(url, data, cb) {
    this.$http.delete(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  deletes(url, cb) {
    this.$http.delete(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  //------------------------------------------------------------
  //看了该猎头还看
  getOtherHunter(hunterName, cb) {
    // console.log("老子调用了SimilarHunter这个借口啊啊啊啊");
    this.get(`/hunter/${hunterName}/otherHunter/see?pageNum=1&pageSize=6`, cb)
  }
}
class apiFactory {
  constructor() {

  }
  createApi(axios) {
    return new or_api(axios)
  }
}
export default new apiFactory();
